<template>
    <layout>
        <div class="d-flex flex-column justify-content-center align-items-center h-100">
            <template v-if="status === 404">
                <i class="fas fa-exclamation-circle fa-4x"></i>
                <h3>Not Found (404)</h3>
                <p>The resource you are looking for was not found.</p>
            </template>
            <template v-else>
                    <i class="fas fa-bomb fa-4x text-danger"></i>
                    <h3 class="text-danger">Server Error ({{ status }})</h3>
                    <p class="text-danger">An unknown error has occured.</p>
                    <button class="btn btn-danger btn-lg rounded-xl px-5 mt-4" @click="goBack">Try again?</button>
            </template>
        </div>
    </layout>
</template>

<script>
import Layout from './Layout';

export default {
    name: 'ErrorHandler',
    components: {
        Layout,
    },
    computed: {
        status() {
            return this.$route.params.status || 500;
        }
    },
    methods: {
        goBack() {
            this.$router.replace({name: 'home', params: {id: this.$route.params.id }});
        },
    },
}
</script>
